import * as yup from 'yup'

const regex = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im

export const registerFormValid = yup.object().shape({
    // userAddressNumber: yup.string().required('message.fieldRequired'),
    // userCity: yup.string().required('message.fieldRequired'),
    userEmail: yup
        .string()
        .required('message.fieldRequired')
        .email('message.invalidEmail'),
    userName: yup.string().required('message.fieldRequired'),
    // userOfficeName: yup.string().required('message.fieldRequired'),
    userPassword: yup
        .string()
        .required('message.fieldRequired')
        .min(6, 'message.minLength'),
    confirmPassword: yup.string().when('isUpdate', {
        is: false,
        then: yup
            .string()
            .required('message.fieldRequired')
            .test({
                name: 'matchPassword',
                message: 'message.confirmPasswordNotMatch',
                test: function (val) {
                    return val === this.parent.userPassword
                },
            })
            .min(6, 'message.minLength'),
    }),
    // userPostcode: yup.string().required('message.fieldRequired'),
    // userStreet: yup.string().required('message.fieldRequired'),
    userUsername: yup
        .string()
        .required('message.fieldRequired')
        .min(6, 'message.minLength'),
    // floor: yup.string().required('message.fieldRequired'),
    userPhone: yup.string().required('message.fieldRequired'),
})

export const updatePasswordFormValid = yup.object().shape({
    userPassword: yup
        .string()
        .required('message.fieldRequired')
        .min(6, 'message.minLength'),
    userNewPassword: yup
        .string()
        .required('message.fieldRequired')
        .min(6, 'message.minLength'),
    confirmNewPassword: yup
        .string()
        .required('message.fieldRequired')
        .min(6, 'message.minLength')
        .test({
            name: 'matchPassword',
            message: 'message.confirmPasswordNotMatch',
            test: function (val) {
                return val === this.parent.userNewPassword
            },
        }),
})

export const restPasswordFormValid = yup.object().shape({
    otp: yup.string().required('message.fieldRequired'),
    newPassword: yup
        .string()
        .required('message.fieldRequired')
        .min(6, 'message.minLength'),
    confirmNewPassword: yup
        .string()
        .required('message.fieldRequired')
        .min(6, 'message.minLength')
        .test({
            name: 'matchPassword',
            message: 'message.confirmPasswordNotMatch',
            test: function (val) {
                return val === this.parent.newPassword
            },
        }),
})

export const forgotPasswordFormValid = yup.object().shape({
    email: yup
        .string()
        .required('message.fieldRequired')
        .email('message.invalidEmail'),
})

export const loginFormValid = yup.object().shape({
    username: yup
        .string()
        .required('message.fieldRequired')
        .min(6, 'message.minLength'),
    password: yup
        .string()
        .required('message.fieldRequired')
        .min(6, 'message.minLength'),
})

export const customerInfoValid = yup.object().shape({
    userAddressNumber: yup.string().required('message.fieldRequired'),
    userCity: yup.string().required('message.fieldRequired'),
    // userEmail: yup
    //     .string()
    //     .required('message.fieldRequired')
    //     .email('message.invalidEmail'),
    userName: yup.string().required('message.fieldRequired'),
    // userOfficeName: yup.string().required('message.fieldRequired'),
    userPhone: yup.string().required('message.fieldRequired'),
    userPostcode: yup.string().required('message.fieldRequired'),
    userStreet: yup.string().required('message.fieldRequired'),
    // floor: yup.string().required('message.fieldRequired'),
})

export const addressValid = yup.object().shape({
    addressNumber: yup.string().required('message.fieldRequired'),
    street: yup.string().required('message.fieldRequired'),
    zipCode: yup.string().required('message.fieldRequired'),
    city: yup.string().required('message.fieldRequired'),
})
